import Keycloak from "keycloak-js"

const keycloakConfig = {
  url: "https://auth.heig-vd.ch",
  realm: "main",
  clientId: "ateliers-jp-app",
}

const keycloak = new Keycloak(keycloakConfig)

export default keycloak
